<template>
  <form
    class="payroll-detail"
    @submit.prevent="onSubmit"
  >
    <div class="columns is-multiline is-centered">
      <div class="column is-6">
        <PayrollDetails
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-6">
        <PayrollReceiver
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-12">
        <PayrollPercepts
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-12">
        <PayrollDeductions
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-12">
        <PayrollOtherPayments
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-12">
        <PayrollPaidLeaves
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-12 action-buttons">
        <div
          v-if="stamped || canceled"
          class="field is-grouped"
        >
          <p class="control">
            <RouterLink
              class="button"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              :to="{ name: 'SaleNoteList', query: { size: 20, page: 1 } }"
            >
              Regresar
            </RouterLink>
          </p>
        </div>
        <div
          v-else
          class="field is-grouped"
        >
          <p class="control">
            <RouterLink
              class="button"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              :to="{ name: 'PayrollsList', query: { size: 20, page: 1 } }"
            >
              Regresar
            </RouterLink>
          </p>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'PayrollDetail',
  components: {
    PayrollDetails: () => import(/* webpackChunkName: "payroll-details" */ '@/components/Admin/Payroll/PayrollDetails.vue'),
    PayrollReceiver: () => import(/* webpackChunkName: "payroll-receiver" */ '@/components/Admin/Payroll/PayrollReceiver.vue'),
    PayrollPercepts: () => import(/* webpackChunkName: "payroll-percepts" */ '@/components/Admin/Payroll/PayrollPercepts.vue'),
    PayrollDeductions: () => import(/* webpackChunkName: "payroll-deductions" */ '@/components/Admin/Payroll/PayrollDeductions'),
    PayrollOtherPayments: () => import(/* webpackChunkName: "payroll-other-payments" */ '@/components/Admin/Payroll/PayrollOtherPayments.vue'),
    PayrollPaidLeaves: () => import(/* webpackChunkName: "payroll-paid-leaves" */ '@/components/Admin/Payroll/PayrollPaidLeaves.vue'),
  },
  data() {
    return {
      isLoading: false,
      stamp: false,
    };
  },
  computed: {
    ...mapState({
      stamped: state => state.invoice.operation.isSaleNote,
      status: state => state.invoice.operation.status,
    }),
    canceled() {
      return [201, 202].includes(this.status);
    },
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getPayrollByUuid(this.$route.params.uuid);
    this.isLoading = false;
  },
  methods: {
    ...mapMutations({
      setPayrollValues: 'payroll/setValues',
    }),
    ...mapActions({
      getPayrollByUuid: 'payroll/getByUuid',
    }),
    setStamp(value) {
      this.stamp = value;
    },
  },
};
</script>

<style scoped>
.payroll-detail {
  padding: 1rem;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
}

@media screen and (min-width: 1280px) {
  .box {
    flex-direction: column;
  }

  .label.is-centered::before {
    top: inherit;
  }
}
</style>
